import api from './base';
import i18n from '../../i18n';

export const authApi = {
  login: (username, password, captchaToken) =>
    api.post('/users/login', { username, password, captchaToken }),

  register: (username, email, password, captchaToken) =>
    api.post('/users/register', { username, email, password, captchaToken, language_code: i18n.language }),

  verifyEmail: (activationToken) =>
    api.post('/users/verify-email', { activationToken }),

  resetPasswordWithToken: (token, newPassword) =>
    api.post('/users/reset-password-with-token', { token, new_password: newPassword, language_code: i18n.language }),

  logout: (token) =>
    api.post('/users/logout', {}, { headers: { Authorization: `Token ${token}` } }),

  refreshToken: (token) =>
    api.post('/users/refresh-token', {}, { headers: { Authorization: `Token ${token}` } }),

  getUserInfo: (token) =>
    api.get('/users/user-info', { headers: { Authorization: `Token ${token}` } }),
};
